module.exports = "<form v-on:submit.prevent=emitQueryChange(value) class=c-search-sidebar__freetext-wrapper> <input class=c-search-sidebar__freetext type=text v-model=currentQuery :placeholder=\"trans('Search Text')\"/><button class=\"c-search-sidebar__submit i-icon i-search-btn_small\" type=submit> {{ trans(\"Search\") }} </button> </form> ";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/pages/explore-the-archive/archive/templates/freetext-search.html
// module id = 140
// module chunks = 0